import React, { useEffect, useState } from "react"
import { timePassedText } from "../../../utils/DateAndTime"
import "./style.scss"

function RefreshButtonWithTimer({
  lastUpdateTime,
  onRefresh,
  cooldownMs = 3000,
  updateIntervalMs = 10000,
}) {
  const [tick, setTick] = useState(0)
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1)
    }, updateIntervalMs)

    return () => clearInterval(interval)
  }, [updateIntervalMs])

  const handleClick = () => {
    if (disabled) return
    onRefresh()
    setDisabled(true)
    setTimeout(() => setDisabled(false), cooldownMs)
  }

  return (
    <div
      className={`last-refresh-date${disabled ? " disabled" : ""}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === "Enter" || e.key === " ") && !disabled) {
          handleClick()
        }
      }}
      aria-disabled={disabled}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      הנתונים עודכנו {timePassedText(lastUpdateTime)} - לחץ לרענון
    </div>
  )
}

export default RefreshButtonWithTimer
